/* @ngInject */
const settingRequest = (
  $q,
  settingResources,
  errorHandler,
  valueHandler,
  labels
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$setting.getBySearch'
      settingResources.post({
        action: 'search',
      }, { search: _data }, (res) => {
        console.log('getBySearch', res)

        if (res && res.success && res.data) {
          const response = {
            settings: res.data[0],
            message: labels.setting.log.search.success,
            color: 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.setting.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.save = (_data) => {
    // return $q((resolve, reject) => {
    //   const functionName = '$$setting.save'
    //   settingResources.save({}, _data, (res) => {
    //     if (res && res.success && res.message) {
    //       resolve(res.message)
    //     } else if (valueHandler.isString(res)) {
    //       reject(res)
    //     } else {
    //       errorHandler.message(res, functionName, _data)
    //       reject(labels.setting.log.save.failure)
    //     }
    //   }, (error) => {
    //     errorHandler.status(error, functionName)
    //     reject(labels.log.failure)
    //   })
    // })
    return $q((resolve, reject) => {
      const functionName = '$$setting.update'
      settingResources.post({ action: 'update-by-user' }, _data, (res) => {
        if (res && res.success && res.message && res.data) {
          const response = {
            message: res.message,
            setting: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.setting.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.saveGeneral = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$setting.saveGeneral'

      console.log('saveGeneral', _data)

      settingResources.post({
        action: 'register-or-update',
      }, _data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.setting.log.save.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (data) => {
    return $q((resolve, reject) => {
      const functionName = '$$setting.update'
      settingResources.post({ action: 'update-by-user' }, data, (res) => {
        if (res && res.success && res.message && res.data) {
          const response = {
            message: res.message,
            setting: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.setting.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$$setting.delete'
      const data = {
        id: _id,
      }

      settingResources.delete(data, (res) => {
        if (res && res.success) {
          resolve(labels.setting.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.setting.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default settingRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/services/requests.service.js